import request from '../utils/request.js';
import { getTpDataSign } from '../utils/rsa.js';
let apiConfig = null;
try {
  apiConfig = require('../../src/config/api').default;
} catch (e) {
  // 文件不存在时忽略错误
}
const baseUrl = apiConfig?.VUE_APP_GIAM_Common || process.env.VUE_APP_GIAM_Common;
// 添加标签
export function saveConfigLabel(data) {
  return request({
    baseURL: baseUrl,
    url: '/ads/saveConfigLabel',
    method: 'post',
    data: JSON.stringify(data),
    withCredentials: false,
    headers: { ...getTpDataSign(data) },
    transformRequest: [
      function (data) {
        return data;
      },
    ],
  });
}
// 删除标签
export function delLabel(data) {
  return request({
    baseURL: baseUrl,
    url: `/ads/delLabel?labelId=${data.labelId}`,
    method: 'post',
    data: JSON.stringify(data),
    headers: { ...getTpDataSign(data) },
    transformRequest: [
      function (data) {
        return data;
      },
    ],
  });
}
// 添加标签广告关联关系
export function saveAdLabel(data) {
  return request({
    baseURL: baseUrl,
    url: `/ads/saveAdLabel`,
    method: 'post',
    data: JSON.stringify(data),
    headers: { ...getTpDataSign(data) },
    withCredentials: false,
    transformRequest: [
      function (data) {
        return data;
      },
    ],
  });
}
// 删除标签广告的关联关系
export function delAdLabel(data) {
  return request({
    baseURL: baseUrl,
    url: `/ads/delAdLabel`,
    method: 'post',
    data: JSON.stringify(data),
    headers: { ...getTpDataSign(data) },
    transformRequest: [
      function (data) {
        return data;
      },
    ],
  });
}
